module.exports = __webpack_public_path__ + "static/media/PDF1.aea3f37e.pdf";